import { render, staticRenderFns } from "./InventoryPurchaseInvoices.vue?vue&type=template&id=25254f24"
import script from "./InventoryPurchaseInvoices.vue?vue&type=script&lang=js"
export * from "./InventoryPurchaseInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports